import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

const overview = async (params = {}) => axiosGet(`${BASE_URL}/design-themes/overview`, params);

// Themes
const listThemes = async () => axiosGet(`${BASE_URL}/design-themes/list`);
const saveTheme = async (params) => params instanceof FormData ? axiosPostWithFile(`${BASE_URL}/design-themes/save`, params) : axiosPost(`${BASE_URL}/design-themes/save`, { ...params });
const updateThemeStatus = async (id, status) =>
  axiosPost(`${BASE_URL}/design-themes/status`, { id, status });
const deleteTheme = async (id) => axiosPost(`${BASE_URL}/design-themes/delete`, { id });

// Activations
const listActivations = async (params = {}) =>
  axiosGet(`${BASE_URL}/design-themes/activations`, { ...params });
const saveActivation = async (params) =>
  axiosPost(`${BASE_URL}/design-themes/activation/save`, { ...params });
const updateActivationStatus = async (id, status) =>
  axiosPost(`${BASE_URL}/design-themes/activation/status`, { id, status });
const deleteActivation = async (id) =>
  axiosPost(`${BASE_URL}/design-themes/activation/delete`, { id });

// Resolve (preview)
const resolveTheme = async (params = {}) =>
  axiosGet(`${BASE_URL}/design-themes/resolve`, { ...params });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  overview,
  listThemes,
  saveTheme,
  updateThemeStatus,
  deleteTheme,
  listActivations,
  saveActivation,
  updateActivationStatus,
  deleteActivation,
  resolveTheme,
};

